import { t } from "../../services/utils";
import { CREATE_APP_EVENT } from '../../constants/action-types';
import appEvents from '../../constants/app-events';
export const sendAppLaunchedEvent = () => {
  return {
    type: CREATE_APP_EVENT.REQUEST,
    payload: {
      app_event_type: appEvents.APP_LAUNCHED
    }
  };
};
export const sendAppInviteSentEvent = clientId => {
  return {
    type: CREATE_APP_EVENT.REQUEST,
    payload: {
      app_event_type: appEvents.CLIENT_INVITE_SENT,
      user_id: clientId
    }
  };
};